<template lang="pug">
.question-detail
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/master") {{ $t('Master Manage')}}
    li
      router-link(to="/question") {{ $t('Master Service Questions List') }}
    li.active
      span {{ $t('Master Service Questions Detail') }}

  //- タイトル
  h2(style="text-align: center;") {{ $t('Master Service Questions Detail') }}

  .row
    .row.margin-top
      .col-xs-2.text-right
        .form-group
          label.control-label
            span タイトル
      .col-xs-10
        .form-group
          span {{title}}
    template(v-for="(question, index) in questions")
      .row.margin-top.text-center
        h3 評価項目 {{index + 1}}
      .row.margin-top
        .col-xs-3.text-right
          .form-group
            label.control-label
              span カテゴリー
        .col-xs-9
          .form-group
            span {{ question.attributes['service-question-category-name'] }}
      .row.margin-top
        .col-xs-3.text-right
          .form-group
            label.control-label
              span 評価して欲しいシーン
        .col-xs-9
          .form-group
            span(v-html="newLineContent(question.attributes['question-scene'])")
      .row.margin-top
        .col-xs-3.text-right
          .form-group
            label.control-label
              span 評価項目
        .col-xs-9
          .form-group
            span(v-html="newLineContent(question.attributes['question-content'])")
      .row.margin-top
        .col-xs-3.text-right
          .form-group
            label.control-label
              span 評価点数（満点）
        .col-xs-9
          .form-group
            span {{ question.attributes['max-point'] }}

    .row.margin-top
      .col-sm-12.text-right
        a.btn.btn-info.margin-right(v-on:click="onClickEdit()")
          i.fa.fa-pencil
          span {{ $t('Edit') }}
        a.btn.btn-info(v-on:click="onClickCancel()")
          i.fa.fa-times
          span {{ $t('Back') }}
</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'master-service-question-detail',
  created () {
    this.search()
  },
  data () {
    return {
      title: '',
      questions: []
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      this.$store.dispatch('GET_MASTER_SERVICE_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        this.title = res.title
        if (res.question_details.data.length > 0) {
          this.questions = res.question_details.data
        }
      })
      .catch(err => console.log(err))
    },
    newLineContent: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    },
    onClickEdit: function () {
      this.$router.push({ path: `/master/service_questions/${this.$route.params.id}/edit` })
    },
    onClickCancel: function () {
      this.$router.push({ path: '/master/service_questions' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// MasterServiceQuestionDetail.vue?614c38f6